/**
 * BULK_LOAD_CARD_STATUS_TEXT
 *
 * This is to be derived from single load status
 */
var BULK_LOAD_CARD_STATUS_TEXT;
(function (BULK_LOAD_CARD_STATUS_TEXT) {
    BULK_LOAD_CARD_STATUS_TEXT["PUBLISHED"] = "Published";
    BULK_LOAD_CARD_STATUS_TEXT["UNDER_REVIEW"] = "Under Review";
    BULK_LOAD_CARD_STATUS_TEXT["FULFILLED"] = "Fulfilled";
    BULK_LOAD_CARD_STATUS_TEXT["PARTIAL_FULFILLED"] = "Partially Fulfilled";
    BULK_LOAD_CARD_STATUS_TEXT["CANCELLED"] = "Cancelled";
    BULK_LOAD_CARD_STATUS_TEXT["EXPIRED"] = "Expired";
})(BULK_LOAD_CARD_STATUS_TEXT || (BULK_LOAD_CARD_STATUS_TEXT = {}));

export { BULK_LOAD_CARD_STATUS_TEXT };
//# sourceMappingURL=bulkLoadCardStatus.js.map
